import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  public versionBuild: number = 20210923;
  public versionMajor: number = 1;
  public versionMinor: number = 0;
  public versionRevision: number = 0;
}
